import { FC, useContext } from 'react';

import { RedeliveryContext } from '../redelivery-context';

const RedeliveryNotes: FC<{ className?: string }> = ({ className = '' }) => {
  const { notes, setNotes } = useContext(RedeliveryContext);

  return (
    <div className={`text-field h-100 ${className}`}>
      <textarea
        className="h-100 w-100"
        data-cy="redelivery-notes-input"
        value={notes ?? ''}
        onChange={e => setNotes(e.target.value)}
      />
      <label style={!notes ? undefined : { transform: 'translate(14px, -9px) scale(0.75)' }}>NOTES</label>
    </div>
  );
};

export default RedeliveryNotes;
